<template>
  <div v-if="currentRoles.name === '批次打印'" class="page-index label-print">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['批次打印-添加批次']" class="btn-left" size="mini" @click="openModel(null)">添加批次</el-button>
      <div style="flex:1"></div>
      <el-select v-if="userInfo.companyList.length > 0" class="search-input2" multiple collapse-tags v-model="query.companyIds" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select class="search-input" v-model="flag" @change="seach">
        <el-option label="普通" value="1"></el-option>
        <el-option label="营销" value="2"></el-option>
        <el-option label="SAP" value="3"></el-option>
      </el-select>
      <el-input  class="search-input" size="mini" v-model="query.query" @keyup.enter.native="seach" placeholder="请输入关键字" />
    </div>
    <el-table
        ref="table"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="batch"
          label="批次号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="label.name"
          label="标签名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="product.name"
          label="商品名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="productDate"
          label="生产日期">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="是否打印">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">未打印</div>
          <div v-if="scope.row.status === 2">打印中</div>
          <div v-if="scope.row.status === 3">已完成</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="已打印/数量">
        <template slot-scope="scope">
          <div>{{scope.row.printNum + '/' + scope.row.num}}</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="180"
          label="操作">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.labelId == null" content="选择模板" placement="top">
            <el-button size="mini" @click.stop="handleSelectLabel(scope.row)">
              <i class="icon el-icon-detail"></i>
            </el-button>
          </el-tooltip>
          <div v-else>
            <el-tooltip content="详情" placement="top">
              <el-button size="mini" @click.stop="handleDetail(scope.row)">
                <i class="icon el-icon-detail"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="scope.row.printNum < scope.row.num" content="打印" placement="top">
              <el-button size="mini" @click.stop="openModel3(scope.row)">
                <i class="icon el-icon-print"></i>
              </el-button>
            </el-tooltip>
            <el-tooltip v-if="flag === '1' && scope.row.printNum >= scope.row.num" content="追加打印" placement="top">
              <el-button size="mini" @click.stop="openModel2(scope.row)">
                <i class="icon el-icon-zhuijia"></i>
              </el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加批次"
        :visible.sync="dialogVisible"
        width="550px"
        :close-on-click-modal="false">
      <el-form ref="labelPrint" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="数量"  prop="num">
          <el-input type="number" placeholder="请输入数量" v-model="form.num" min="1"></el-input>
        </el-form-item>
        <el-form-item label="生产日期" prop="productDate">
          <el-date-picker
            v-model="form.productDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="生产班次" prop="type">
          <el-select class="search-input" v-model="form.type" placeholder="请选择生产班次">
            <el-option v-for="item in masterBatch" :key="item.value" :label="item.description" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择公司">
          <el-select class="search-input" v-model="companyId" @change="seach2" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.isBatch === 2" label="批次生成方式">
          <template>
            <el-radio v-model="form.flag" label="1">自动</el-radio>
            <el-radio v-model="form.flag" label="2">手动</el-radio>
          </template>
        </el-form-item>
        <el-form-item v-if="form.isBatch === 2" label="批次号"  :prop="form.flag === '1' ? '' : 'batch'">
          <el-input placeholder="请输入批次号" v-model="form.batch" :disabled="form.flag === '1'"></el-input>
        </el-form-item>
        <el-form-item label="选择标签模板" prop="labelId">
          <el-select
            class="search-input"
            v-model="form.labelId"
            filterable
            collapse-tags
            remote
            :remote-method="getLabelList"
            @change="previewLabel"
            placeholder="请选择标签模板"
          >
            <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="previewLabel">
        <iframe
          v-if="pid !== ''"
          id="iframe"
          :src="root + 'service/buildPage.jsp?tid=' + tid + '&pid=' + pid"
          frameborder="0"
          scrolling="no"
          style="background:#fff;">
        </iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="添加批次(营销)"
        :visible.sync="dialogVisible2"
        width="550px"
        :close-on-click-modal="false">
      <el-form ref="labelPrint2" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="畜牧局信息上传">
          <el-upload
              ref="fileUpload"
              action=""
              :limit="1"
              :auto-upload="false"
              :on-change="handleChange"
              :on-remove="handleRemove">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="生产日期" prop="productDate">
          <el-date-picker
            v-model="form.productDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="生产班次" prop="type">
          <el-select class="search-input" v-model="form.type" placeholder="请选择生产班次">
            <el-option v-for="item in masterBatch" :key="item.value" :label="item.description" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择公司">
          <el-select class="search-input" v-model="companyId" @change="seach2" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择标签模板" prop="labelId">
          <el-select
            class="search-input"
            v-model="form.labelId"
            filterable
            collapse-tags
            remote
            :remote-method="getLabelList"
            @change="previewLabel"
            placeholder="请选择标签模板"
          >
            <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="previewLabel">
        <iframe
          v-if="pid !== ''"
          id="iframe"
          :src="root + 'service/buildPage.jsp?tid=' + tid + '&pid=' + pid"
          frameborder="0"
          scrolling="no"
          style="background:#fff;">
        </iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="批次打印详情"
        :visible.sync="dialogVisible3"
        width="750px">
      <el-table
          ref="table"
          :data="printDetailList"
          stripe
          size="mini"
          empty-text="暂无数据"
          row-class-name="table-row-cursor"
          header-row-class-name="header-row"
          :height="tableHeight"
          :maxHeight="tableHeight"
          style="width: 100%;">
        <el-table-column
            header-align="center"
            align="center"
            type="index"
            width="50"
            label="#">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="number"
            label="唯一码">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="是否打印">
          <template slot-scope="scope">
            <div>{{scope.row.status === 0 ? '否' : '是'}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
            header-align="center"
            align="center"
            width="150"
            label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 0" size="mini" @click.stop="handlePrint(scope.row)">打印</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogVisible4"
      title="打印任务"
      width="550px"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <iframe v-if="dialogVisible4" :src="printUrl" frameborder="0" scrolling="no" style="width:100%;height:220px"></iframe>
    </el-dialog>

    <el-dialog
        title="追加打印"
        :visible.sync="dialogVisible5"
        width="550px"
        :close-on-click-modal="false">
      <el-form ref="zhuijia" :rules="rules" :model="form2" label-width="180px">
        <el-form-item label="数量"  prop="num">
          <el-input type="number" placeholder="请输入数量" v-model="form2.num" min="1"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="handleExAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="选择打印模板"
        :visible.sync="dialogVisible7"
        width="550px"
        :close-on-click-modal="false">
      <el-form ref="muban" :rules="rules" :model="form3" label-width="180px">
        <el-select class="search-input2" v-model="form3.labelId" placeholder="请选择模板">
          <el-option v-for="item in labels" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible7 = false">取 消</el-button>
        <el-button type="primary" @click="_setLabel">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="打印任务"
        :visible.sync="dialogVisible6"
        width="550px"
        :close-on-click-modal="false"
        :before-close="handleClose">
      <div class="printer-box">
        <ul>
          <li>批次号：{{printRow.batch}}</li>
          <li>数量：{{unprintNum}}</li>
          <!-- <li>已打印数量：{{printedNum}}</li> -->
          <li v-if="printStatus === 0">打印状态：未开始打印</li>
          <li v-if="printStatus === 1">打印状态：打印任务传输中</li>
          <li v-if="printStatus === 2">打印状态：正在打印中</li>
          <li v-if="printStatus === 3">打印状态：打印完成</li>
          <li>
            <span>选择打印机：</span>
            <el-select class="search-input2" @change="setDefaultPrinter" v-model="printer" placeholder="请选择打印机">
              <el-option v-for="item in printers" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </li>
          <li v-show="false">
            <span>任务大小：</span>
            <el-input class="input" v-model="takeNum" type="number" :disabled="checked"></el-input>
            <el-checkbox v-model="checked">默认设置</el-checkbox>
            <div style="color:red;font-size:16px;">*注：一次任务最多50张，最少10张</div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="printStatus === 0 || printStatus === 3" type="primary" @click="handlePrint(false)">打印</el-button>
        <el-button v-if="printStatus === 1 || printStatus === 2" type="info">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate, dataFormart } from '../../utils/common'
  import { apiUpload } from '../../api/file'
  import { apiLabelList, apiLabelPrintList, apiLabelPrintEdit, apiGetPid } from '../../api/label'
  import { apiList, apiAdd, apiUpdateStatus, apiDetail, view, getLabelListByPrintId, setLabel } from '../../api/labelPrint'
  import { apiBatch } from '../../api/master'
  import { getJCP } from '../../../public/jcp'
  import DDDY from '../../../public/dddy'

  export default {
    mixins: [tableMixin],
    name: 'userInfo',
    data() {
      const numberRule = (rule, value, callback) => {
        if (value > 1500) {
          callback(new Error('数量不能超过1500'))
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          callback(new Error('数量必须是正整数'))
        } else {
          callback()
        }
      }
      return {
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        dialogVisible5: false,
        dialogVisible6: false,
        dialogVisible7: false,
        labels: [],
        timeout: {},
        printers: [], // 打印机列表
        printer: '', // 选中的打印机
        unprintNum: 0, // 未打印的数量
        printedNum: 0, // 已经打印的数量
        takeNum: 10, // 任务数量
        checked: true, // 默认设置
        printStatus: 0, // 0未开始 1任务传输中 2正在打印中 3打印完成
        jobList1: [], // 任务1
        jobList2: [], // 任务2
        labelPrintId: '', // 追加打印用
        key: '', // token用
        interval: '', // 定时器
        root: process.env.VUE_APP_DDDY_ROOT,
        pid: '',
        tid: '',
        printUrl: '/printer/api/print.html',
        list: [],
        list2: [],
        productList: [],
        file: null,
        pageIndex: 1,
        total: 0,
        printRow: {}, // 打印用
        printDetailList: [],
        currentRow: {
          printDetailList: []
        },
        companyId: null,
        masterBatch: [], // 生产班次
        id: 0,
        flag: '1', // 1.普通 2.营销
        query: {
          query: '',
          companyIds: []
        },
        form: {
          num: '',
          productDate: '',
          labelId: '',
          type: 1,
          flag: '1',
          isBatch: 1,
          batch: ''
        },
        form2: {},
        form3: {},
        rules: {
          num: [
            { required: true, message: '请输入数量', trigger: 'blur' },
            { validator: numberRule, trigger: 'blur' }
          ],
          productDate: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          labelId: [
            { required: true, message: '请选择模板', trigger: 'change' }
          ],
          type: [
            { required: true, message: '请选择批次', trigger: 'change' }
          ],
          batch: [
            { required: true, message: '请输入批次号', trigger: 'blur' }
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      if (this.userInfo.companyList) {
        this.query.companyIds.push(this.userInfo.companyList[0].id)
        this.companyId = this.userInfo.companyList[0].id
        this._getList()
        this.getLabelList()
      }
    },
    activated() {
      this.key = (localStorage.getItem('companyCode') || '').toLowerCase() + '_' + (localStorage.getItem('account') || '')
      this.takeNum = localStorage.getItem('takeNum') || 10
      this.getPrinters()
      this._getList()
      this.getLabelList()
      this.getMasterBatch()
    },
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 打开model
      openModel() {
        this.pid = ''
        this.tid = ''
        let me = this
        this.interval = window.setInterval(function() {
          me.reinitIframe()
        }, 1000)
        if (this.flag === '1') {
          this.dialogVisible = true
        } else {
          this.dialogVisible2 = true
        }
        this.form = {
          num: '',
          productDate: new Date(),
          labelId: '',
          type: 1,
          flag: '1',
          isBatch: 1,
          batch: ''
        }
        let company = this.userInfo.companyList.filter(item => {
          return item.id === this.companyId
        })
        this.form.isBatch = company[0].isBatch
        if (this.$refs['labelPrint']) {
          this.$refs['labelPrint'].resetFields()
        }
        if (this.$refs['labelPrint2']) {
          this.$refs['labelPrint2'].resetFields()
        }
        this.getLabelList()
      },
      // 追加打印模态框
      openModel2(row) {
        this.labelPrintId = row.id
        this.form2 = {
          num: ''
        }
        this.dialogVisible5 = true
        if (this.$refs['zhuijia']) {
          this.$refs['zhuijia'].resetFields()
        }
      },
      _setLabel() {
        setLabel(this.form3.labelPrintId, this.form3.labelId).then(_ => {
          this.$message({
            type: 'success',
            message: '设置成功'
          })
          this.dialogVisible7 = false
          this.seach()
        })
      },
      // 追加打印
      handleExAdd() {
        if (this.labelPrintId === null || this.labelPrintId === 0) return
        this.$refs['zhuijia'].validate((valid) => {
          if (valid) {
            apiAdd(this.labelPrintId, this.form2.num).then(() => {
              this.$message({
                type: 'success',
                message: `该批次已追加${this.form2.num}张`
              })
              this._getList()
              this.dialogVisible5 = false
            })
          }
        })
      },
      // 点击打印
      openModel3(row) {
        this.printRow = row
        this.unprintNum = row.num - row.printNum
        this.printedNum = 0
        this.printStatus = 0
        // this.dialogVisible6 = true
        // window.open(`/printer/api/print.html?labelPrintId=${row.id}&number=${row.label.number}`)
        window.open(`/print/index?labelPrintId=${row.id}&number=${row.label.number}`, `print${new Date().getTime()}`, 'height=310, width=453, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, status=no')
      },
      _getDetail(row) {
        apiDetail(row.id).then(data => {
          this.printDetailList = data.data
        })
      },
      _getLabelListByPrintId(row) {
        getLabelListByPrintId(row.id).then(data => {
          this.labels = data.data
        })
      },
      // 选择模板
      handleSelectLabel(row) {
        this._getLabelListByPrintId(row)
        this.form3.labelPrintId = row.id
        this.dialogVisible7 = true
      },
      // 详情
      handleDetail(row) {
        this._getDetail(row)
        this.currentRow = row
        this.dialogVisible3 = true
      },
      // 文件改变
      handleChange(file, files) {
        let arr = file.name.split('.')
        let suffix = arr[arr.length - 1]
        if (suffix !== 'txt') {
          this.$refs.fileUpload.clearFiles()
          this.$message({
            type: 'warning',
            message: '请上传txt文件'
          })
          return
        }
        this.file = file
      },
      // 移除文件
      handleRemove() {
        this.file = null
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
          this.dialogVisible3 = false
          this.dialogVisible4 = false
          this.dialogVisible5 = false
          this.dialogVisible6 = false
          window.clearInterval(this.interval)
        }).catch(_ => {})
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      // 搜索2
      seach2() {
        this.getLabelList()
        let company = this.userInfo.companyList.filter(item => {
          return item.id === this.companyId
        })
        this.form.isBatch = company[0].isBatch
      },
      // 获取生产班次
      getMasterBatch() {
        apiBatch().then(({ data }) => {
          this.masterBatch = data
        })
      },
      // 获取标签模板列表
      getLabelList(value = '', pageIndex = 1) {
        apiLabelList(2, 0, { companyIds: [this.companyId], query: value }, pageIndex, 9999).then(data => {
          this.list2 = data.data.data
        })
      },
      // 获取列表批次列表
      _getList(pageIndex = 1) {
        if (this.query.companyIds.length === 0) return
        apiLabelPrintList(this.query, this.flag, 1, pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 获取打印机列表
      getPrinters() {
        console.log('获取打印机')
        getJCP().getPrinters(printers => { // 打印机列表
          this.printers = printers
          console.log(printers)
        })
        getJCP().getDefaultPrinter(printer => { // 默认打印机
          this.printer = printer
          console.log(printer)
        })
      },
      // 设置打印机
      setDefaultPrinter() {
        getJCP().setDefaultPrinter(this.printer, () => {
          getJCP().getDefaultPrinter(result => {
            console.log(result)
          })
        })
      },
      // 打印回调
      apiUpdateStatus(that, data, row, flag) {
        apiUpdateStatus(that.printRow.id, this.takeNum).then(() => {
          data.splice(0, this.takeNum)
          if (data.length > 0) {
            console.log('长度:' + data.length)
            that.jcpPrint(data, row, flag)
          } else {
            console.log('长度为零打印完成' + data.length)
            that.printStatus = 3
            that._getList()
          }
        })
      },
      // 打印
      handlePrint(flag) {
        if (this.printStatus === 3) {
          this.$message({
            type: 'warning',
            message: '打印已完成'
          })
          return
        }
        if (this.takeNum > 50 || this.takeNum < 10) {
          this.$message({
            type: 'warning',
            message: '打印任务最多50张，最少10张'
          })
          return
        }
        localStorage.setItem('takeNum', this.takeNum)
        let row = this.printRow
        this.unprintNum = this.printRow.num - this.printRow.printNum
        if (this.unprintNum <= 0) {
          this.$message({
            type: 'warning',
            message: '没有可打印的标签'
          })
          this.printedNum = 0
          return
        }
        this.printStatus = 1
        let that = this
        apiList(row.id).then(data => {
          that.jcpPrint(data.data, row, flag)
        })
      },
      jcpPrint(data, row, flag) {
        let that = this
        let length = data.length
        if (length <= 0) return
        let arr = [...data].splice(0, this.takeNum)
        let dataset = JSON.stringify(dataFormart(arr)) // 10张
        DDDY.getToken(that.key, function(result) {
          if (result.token) {
            DDDY.print(result.token, row.label.number, dataset, flag, function(res) {
              if (res) {
                that.$message({
                  type: 'warning',
                  message: '打印失败'
                })
              } else {
                that.printStatus = 2
                that.apiUpdateStatus(that, data, row, flag)
              }
            })
          }
        })
      },
      // 新增
      handleAdd() {
        let labelPrint = {}
        if (this.flag === '1') {
          this.$refs['labelPrint'].validate((valid) => {
            if (valid) {
              if (this.form.isBatch === 2 && this.form.batch === '') {
                this.$message({
                  type: 'warning',
                  message: '请输入批次号'
                })
                return
              }
              labelPrint = {
                num: this.form.num,
                productDate: formatDate(this.form.productDate, 'YYYY-MM-DD'),
                companyId: this.companyId,
                labelId: this.form.labelId,
                type: this.form.type,
                batch: this.form.batch,
                origin: 1
              }
              if (this.form.isBatch === 1) {
                delete labelPrint.flag
                delete labelPrint.batch
              }
              if (this.form.flag === '1') {
                delete labelPrint.batch
              }
              apiLabelPrintEdit(labelPrint, Number(this.form.flag)).then(data => {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                window.clearInterval(this.interval)
                this.dialogVisible = false
                this._getList()
              })
            }
          })
        } else {
          this.$refs['labelPrint2'].validate((valid) => {
            if (valid) {
              if (this.file === null) {
                this.$message({
                  type: 'warning',
                  message: '请上传畜牧局信息'
                })
                return
              }
              let param = new FormData()
              param.append('file', this.file.raw, this.file.name)
              apiUpload(param).then(data => {
                labelPrint = {
                  num: 0,
                  text: data.data,
                  productDate: formatDate(this.form.productDate, 'YYYY-MM-DD'),
                  companyId: this.companyId,
                  labelId: this.form.labelId,
                  type: this.form.type,
                  origin: 2
                }
                apiLabelPrintEdit(labelPrint, 1).then(data => {
                  this.$message({
                    type: 'success',
                    message: '新增成功'
                  })
                  this.dialogVisible2 = false
                  this._getList()
                })
              })
            }
          })
        }
      },
      // 模板预览
      previewLabel(value) {
        this.pid = ''
        this.tid = ''
        let number = this.list2[this.list2.findIndex(item => item.id === value)].number
        let dataset = ''
        view(value, formatDate(this.form.productDate, 'YYYY-MM-DD')).then(data => {
          dataset = JSON.stringify(dataFormart([data.data]))
          let that = this
          DDDY.getToken(that.key, function(result) {
            if (result.token) {
              apiGetPid(result.token, number, dataset).then(res => {
                if (res.error_code === 0) {
                  that.pid = res.pid
                  that.tid = res.tid
                } else if (res.error_code === 1) {
                  that.pid = ''
                  that.tid = ''
                } else {
                  that.pid = ''
                  that.tid = ''
                }
              })
            }
          })
        })
      },
      reinitIframe() {
        try {
          var iframe = document.getElementById('iframe')
          var bHeight = iframe.contentWindow.document.body.scrollHeight
          var dHeight = iframe.contentWindow.document.documentElement.scrollHeight
          var height = Math.max(bHeight, dHeight)
          iframe.height = height
          var imgTags = iframe.contentWindow.document.getElementsByTagName('img')
          for (let i = 0; i < imgTags.length; i++) {
            try {
              if (imgTags[i].dataset.style.indexOf('type:qr;') !== -1) {
                imgTags[i].src = 'http://127.0.0.1:31227/api?type=coder&code=test&style=type%3Aqr%3Bbar-color%3A%23000000%3Bautofit%3Atrue&width=53&height=51&'
                imgTags[i].dataset.style = ''
              }
              if (imgTags[i].dataset.style.indexOf('type:code39;') !== -1) {
                imgTags[i].src = 'http://127.0.0.1:31227/api?type=coder&code=TEST000000001&style=type%3Acode39%3Bbar-color%3A%23000000%3Btext-color%3A%23000000%3Bfont-size%3A20%3Bfont-name%3AACaslonPro-Bold%3Bautofit%3Atrue&width=204&height=55&'
                imgTags[i].dataset.style = ''
              }
            } catch (ex) {}
          }
        } catch (ex) {}
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.label-print
    .printer-box
      ul
        list-style-type none
      li
        font-size 18px
        margin-top 20px
      .input
        display inline-block
        margin-right 20px
        width 100px
    .el-form-item__content
      width 200px
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input2
        margin-right 10px
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width 200px
    .previewLabel
      display flex
      justify-content center
      height 100%
      width 100%
</style>
